import styles from "./Text.module.css";

function Text({ preheader, title, body }) {
  return (
    <div className={styles.textContainer}>
      <p className={styles.preheader}>{preheader}</p>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.body}>{body}</p>
    </div>
  );
}

export default Text;
